<template>
  <div>
    <h3>Quiz</h3>
    <vs-breadcrumb class="mt-2">
      <li><router-link to="/surveys">Surveys</router-link><span class="vs-breadcrum--separator">/</span></li>
      <li v-if="item" aria-current="page" class="active">Quiz - {{ $translate(item.title) }}</li>
    </vs-breadcrumb>
    <vs-tabs :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none mt-8" id="profile-tabs" :key="isSmallerScreen">

      <!-- GENERAL -->
      <vs-tab icon-pack="feather" icon="icon-info" :label="!isSmallerScreen ? 'General' : ''">
        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
          <quiz-general v-if="item" :item="item" />
        </div>
      </vs-tab>

      <!-- QUESTIONS -->
      <vs-tab icon-pack="feather" icon="icon-info" :label="!isSmallerScreen ? 'Questions' : ''">
        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
          <questions v-if="item" :item="item" survey-type="1" />
        </div>
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
import QuizGeneral from './QuizGeneral.vue'
import Questions from './../components/Questions.vue'

export default {
  components: {
    QuizGeneral,
    Questions
  },
  data () {
    return {
      surveyId: '',
      item: null
    }
  },
  methods: {
    getItem: function () {
      this.$vs.loading()

      const url = process.env.VUE_APP_API +'/Surveys/1/' + this.surveyId;
      
      this.$http.get(url)
          .then(resp => {
            console.log("Quiz:", resp.data);
            this.item = resp.data;
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => {
            this.$vs.loading.close()
          })
    },
  },
  computed: {
    isSmallerScreen () {
      return this.$store.state.windowWidth < 768
    }
  },

  created() {
    this.surveyId = this.$route.params.surveyId;
    this.getItem();
  }
}
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>
